import React from 'react';
import { printables, productName, themes } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { ImageCarousel } from './ImageCarousel';
const dots = ['bg-coral', 'bg-gold', 'bg-leaf', 'bg-navy'];
export function Gallery() {
  return <section id="inside" aria-labelledby="inside-title" className="bg-cream" data-id="element-133" data-mp="3i9vbetqu9ci0">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-134" data-mp="3ddxuombny44p">
        <SectionHeading id="inside-title" title={<>
              Wirf einen Blick in
              <span className="mt-1 block text-[26px] leading-tight text-coral sm:text-[38px]" data-id="element-136" data-mp="2kqadzidijxnc">{productName}</span>
            </>} intro="Hier wiederholen sich nicht nur ein paar Sprüche. Dich erwarten über 200 Bibelverse auf mehr als 20 verschiedenen Designs – eine große Vielfalt an biblischen Botschaften zum Ausdrucken, Ausschneiden und Weitergeben." data-id="element-135" data-mp="2poby86moe30e" />
        <div className="-mx-5 mt-10 sm:-mx-8" data-id="element-137" data-mp="21x6g1kt9iymx">
          <ImageCarousel items={printables} label="Druckfertige Designs zum Weitergeben des Evangeliums" data-id="element-138" data-mp="rckpta45zwbt" />
        </div>

        <div className="mt-16 grid items-center gap-10 rounded-[28px] bg-gold-wash p-8 sm:p-10 lg:grid-cols-[1fr_1.4fr]" data-id="element-139" data-mp="wb4gfntpdwai">
          <div data-id="element-140" data-mp="113nrad10adbm">
            <p className="text-lg font-bold text-navy" data-id="element-141" data-mp="1135xro5qad7e">Du findest Verse und Botschaften zu:</p>
            <p className="mt-6 font-display text-[28px] leading-tight text-navy sm:text-[34px]" data-id="element-142" data-mp="153g4x459b9nu">
              Wähle die passende Botschaft für den Moment.
              <span className="mt-1 block italic text-coral" data-id="element-143" data-mp="dc9zc86rojr6">Druck sie aus. Schneide sie aus. Und gib sie weiter.</span>
            </p>
          </div>
          <ul className="flex flex-wrap gap-3" aria-label="Themen der Botschaften" data-id="element-144" data-mp="hd28z2jjwqnz">
            {themes.map((t, i) => <li key={t} className="inline-flex items-center gap-2.5 rounded-full bg-white px-5 py-3 font-bold text-navy shadow-card" data-id="element-145" data-mp="1stk674uz2xbo" data-mpi={i}>
                <span className={`h-2.5 w-2.5 rounded-full ${dots[i % dots.length]}`} aria-hidden="true" data-id="element-146" data-mp="1xrtz18t85lu4" />
                {t}
              </li>)}
            <li className="inline-flex items-center px-3 py-3 font-bold italic text-ink-soft" data-id="element-147" data-mp="3txm9yggevdfa">… und vieles mehr.</li>
          </ul>
        </div>
      </div>
    </section>;
}